// google 素材上传入库
import { postSaveAdFile } from '../serve/material';
import useUpLoadFileMixin from './useUpLoadFile';
export default {
  mixins: [useUpLoadFileMixin],
  methods: {
    async httpRequest(options) {
      console.log('uploadMaterial httpRequest', options);
      const file = options;
      try {
        //调用架构组素材上传
        const res = await this.useUpLoadFile(file, {
          elOptions: options,
        });
        console.log(res, 'httpRequest');
        res.sourceType = 'SELF_MATERIAL'; //资源来源：SELF_MATERIAL 自建素材
        // 入素材组个人素材库
        const saveRes = await this.saveFileResources(res);
        return saveRes;
      } catch (error) {
        console.log('uploadMaterial httpRequest error', error);
        return { status: 'error', name: file.name };
      }
    },
    // 素材入库 
    async saveFileResources(fileInfo) {
      const { url, md5: md5_code, size: file_size, ext, name: file_name, high, width } = fileInfo;
      let fileData = { url, md5_code, file_size, ext, file_name, play_time: '' };
      if (width && high) {
        fileData.width = width;
        fileData.high = high;
      }
      //固定参数 source 来源来源: 1:上传 2:广告 3:工作流 4:三方工作流 5:混剪 6:广告回传 isAgent 是否需要代理下载: 0:否 1:是
      const defaultParams = { source: 2, isAgent: 0 };
      const params = { ...this.saveAdFileParam, ...defaultParams, fileData: [fileData] };
      try {
        const res = await postSaveAdFile(params);
        if (res?.code !== 0) {
          throw new Error(res);
        }
        return { ...fileInfo, id: res.data[0] };
      } catch (error) {
        console.log('uploadMaterial saveFileResources error', error);
        return { status: 'error', name: file_name };
      }
    },
  },
};
